<template>
    <el-dialog
            title="自己下载" class="fotoo"
            :visible.sync="dialogVisible"
            width="50%" append-to-body
            :before-close="handleClose">
        <div class="tips">单次下载不超过{{oneMaxSize}}M</div>
        <template v-if="residueSize>=totalSize && totalSize>0">
            <div class="text-center">
                本次选中投稿{{totalFile}}个，共计 {{(totalSize/M).toFixed(2)}}M
                <br/>剩余下载额度{{MG(residueSize)}}
            </div>
            <div class="flex-cm" style="padding-bottom: 40px">
                <div class="button source" @click="down('compress')">
                    下载压缩文件
                    <div class="source-tip">省下载额度</div>
                </div>
                <div class="button" @click="down('source')">下载原文件</div>
            </div>
            <el-popover
                    placement="top-start"
                    width="260"
                    trigger="hover">
                <el-button slot="reference" type="text" icon="el-icon-info" style="color:#576B95;padding-left: 30px;">文件命名规则</el-button>
                <div style="font-size: 12px;">文件夹以作者署名命名，没有作者署名以Fotoo用户名称命名；</div>
                <div style="font-size: 12px;">投稿以作品名称命名，没有作品名称以Fotoo用户名称命名</div>
            </el-popover>
        </template>
        <template v-else="">
            <div class="down-text-center">
                本次选中投稿{{totalFile}}个，共计 {{(totalSize/M).toFixed(2)}}M
                <br/>剩余下载额度{{(residueSize/M).toFixed(2)}}M，下载额度不足请充值
            </div>
            <div class="text-center margin-bottom-xl">
                <a href="https://support.qq.com/products/57964/faqs/106896"
                   style="color: #576B95;"
                   target="_blank">如何获取免费下载额度</a>
            </div>
            <div class="flex-cm" style="padding-bottom: 40px" @click="dialogVisible = false">
                <a :href="buyVipUrl" target="_blank">
                    <div class="button source" style="width: 240px;">
                        升级版本，提升下载额度
                        <div class="source-tip">下载额度100G</div>
                    </div>
                </a>
                <router-link
                        :to="'/checkout/buyTraffic?activityId='+draftinfo.activityId+'&activityName='+draftinfo.activityName+'&size='+(totalSize-residueSize)+'&userId='+draftinfo.createBy">
                    <div class="button">直接充下载额度</div>
                </router-link>
            </div>
        </template>
    </el-dialog>
</template>
<script>
  import App from '../../util/comfun'
  const M=1024*1024
  const oneMaxSize=200 //M
  export default {
    props:{
      residueSize:{//剩余下载额度
        type:Number,
        value:0
      },
      draftinfo: {
        type: Object,
        value: {},
      },
    },
    data () {
      return {
        dialogVisibleSimple:false,
        dialogVisible: false,
        activeName: 'self',
        oneMaxSize:oneMaxSize,
        M:M,
        totalFile:0,
        totalSize:0,
        buyVipUrl:'',
      }
    },
    methods:{
      MG:App.MG,
      handleClick(){},
      handleClose(done) {
        done();
      },
      show(res){
        if(res.size>this.oneMaxSize*M){
          let html=`
<div class="flex-lm" style="align-content: flex-start">
    <div style="font-size:34px;color:#FFA200; margin-left:10px;margin-right: 20px;"><i class="el-icon-warning"></i></div>
    <div style="padding-top: 20px;">
        <div style="font-size: 16px;color: #5d5d5d;">超过${this.oneMaxSize}M，建议使用“打包下载”或“单独下载”</div>
    </div>
</div>
`
          this.$alert(html, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '知道了',
            confirmButtonClass:'bg-green',
          });
          return;
        }
        this.dialogVisible=true
        this.totalFile=res.total
        this.totalSize=res.size
      },
      down(type){
        console.log('down',type)
        this.dialogVisible=false
        this.$emit('down',{type:type})
      },
      pay(){
        this.$router.push({
          path:'/pay'
        })
      },
    },
    mounted(){
        this.buyVipUrl=App.buyVipUrl(this.draftinfo.createBy)
    },

  }
</script>

<style>
    .simple{

    }
    .tips{
        padding-left: 60px;
        height: 25px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFang, PingFang-SC;
        font-weight: SC;
        text-align: left;
        color: #999999;
        line-height: 25px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e0e0e0;
    }
    .down-text-center{
        text-align: center;
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #5d5d5d;
        line-height: 30px;
        margin-top: 40px;
        margin-bottom: 70px;
    }
    .button{
        width: 200px;
        height: 60px;
        opacity: 1;
        background: #3dc4a7;
        border-radius: 30px;

        opacity: 1;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
    }
    .source{
        margin-right: 70px;
        position: relative;
    }
    .source-tip{
        position: absolute;
        top:-15px;
        left: 152px;
        min-width: 54px;
        height: 22px;
        opacity: 1;
        background: #ed7b61;
        border-radius: 11px;
        font-size: 12px;
        color: #fefefe;
        display: flex;
        align-items: center;
        text-align: center;
        justify-items: center;
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        white-space:nowrap;
    }
    .source-tip::before{
        position: absolute;
        content: "";
        top:10px;
        left: 0px;
        border-color:  transparent transparent transparent #ED7B61;
        border-width: 10px;
        border-radius: 5px;
        border-style: solid;
    }
    .bg-green{
        background: #3dc4a7;
    }
</style>


// WEBPACK FOOTER //
// src/components/dialog/down.vue